import store from "@/store";
import { NavigationGuardNext, Route } from "vue-router";

function hasAccess(claims: string[]): boolean {
  const user = store.getters["user/getFullAccount"];
  const results = claims
    .map(claim => {
      return user.permissions.indexOf(claim) != -1;
    })
    .filter(hasAccess => !hasAccess);

  return results.length <= 0;
}

/**
 * Redirect forms when not authenticated
 * @param unauthenticated
 * @param unauthorized
 * @param claims
 */
export default (
  unauthenticated: string,
  unauthorized: string,
  claims: string[]
) => (to: Route, from: Route, next: NavigationGuardNext) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next({ name: unauthenticated });
  } else if (!hasAccess(claims)) {
    next({ name: unauthorized });
  } else {
    next();
  }
};
